
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('talktoSoundCapture.vrun.component', () => import('./components/SoundCapture.vue'))


